import { styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const RowCenter = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  width: "max-content",
}));

const styles = makeStyles(() => ({
  mainDiv: {
    minHeight: "inherit",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
  },
  grid: {
    "& .MuiTableContainer-root": {
      overflowY: "hidden",
    },
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "15px",
  },
  noWrap: {
    whiteSpace: "nowrap",
  },
  actionButtons: {
    marginTop: 12,
    width: "100%",
  },
  ssccContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    padding: "4px 12px",
    font: "normal 600 18px/24px Manrope",
    color: "#465869",
  },
  ssccQuantity: {
    font: "normal 700 20px Manrope",
  },
  leftMargin: {
    marginLeft: "8px",
  },
  rowCenter: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  menuActionButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    bottom: 0,
    left: 0,
  },
}));

export default styles;
